import { render, staticRenderFns } from "./ProductsForm.vue?vue&type=template&id=354a6244&"
import script from "./ProductsForm.vue?vue&type=script&lang=ts&"
export * from "./ProductsForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports